import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, UncontrolledDropdown, DropdownMenu, DropdownToggle, Row, DropdownItem, InputGroup, Input } from "reactstrap"

// Image
import defaultImg from "../../../../assets/images/defaultuserimgdark.png"
import profileImg from "../../../../assets/images/profile-img.png"
const baseUrl = process.env.REACT_APP_BASE_URL;
const Settings: React.FC = () => {

  interface UserData {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    get_full_name: string;
    role: string;
    profile_pic: string;

    active: boolean;
    name: string;
    price: string;
    description: string;
    sub_type: string;
  }

  interface UserDataNew {
   

    active: boolean;
    name: string;
    price: string;
    description: string;
    sub_type: string;
  }


  const userDataString = localStorage.getItem("userdata");
  let userData: UserData | null = null;
  if(userDataString){
    try{
      userData = JSON.parse(userDataString);
    }catch(error){
      console.error('Invalid JSON in localstorage',error);
    }
  }

  const userpackdatastring = localStorage.getItem("dumycst");
  let userPackData: UserDataNew | null = null;
  if(userpackdatastring){
    try{
      userPackData = JSON.parse(userpackdatastring);
      if (userPackData && typeof userPackData.active === "string") {
        userPackData.active = userPackData.active === "true";
      }
    }catch(error){
      console.error('Invalid JSON in localstorage',error);
    }
  }
  return (
    <React.Fragment>
      <Col lg={4} className="order-lg-2 order-1">
      <Card className="overflow-hidden rounded-4 mb-5">
        <div className="bg-primary-subtle bgImgGradient">
          <Row>
            <Col xs={7}>
              <div className="text-dark p-3">
                <h5 className="text-dark">Welcome Back !</h5>
                <p>BizServe Dashboard</p>
              </div>
            </Col>
            <Col xs={5} className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm={12}>
              <div className="floatUsertag">
                <Link to="/aprofile" className="btn btn-primary  btn-sm">
                  View Profile <i className="mdi mdi-arrow-right ms-1"></i>
                </Link>
              </div>
              <div className="avatar-md profile-user-wid dash-profile mb-4">
                <img
                  src={userData?.profile_pic || defaultImg}
                  alt=""
                  className="img-thumbnail rounded-circle"
                />
              </div>
              <h5 className="font-size-15 text-dark">{userData?.get_full_name} <span className="badge badge-soft-primary">Admin</span></h5>
              <p className="text-muted mb-0 text-truncate font-size-14 d-flex align-items-center gap-2 mb-1">
                <i className="bx bx-envelope"></i>{userData?.email}</p>
              <p className="text-muted mb-0 text-truncate font-size-14 d-flex align-items-center gap-2 mb-1">
                <i className="bx bxs-phone-call"></i> {userData?.phone}</p>
            </Col>
          </Row>
        </CardBody>
      </Card>

      </Col>
    </React.Fragment>
  )
}

export default Settings;
